
const texts = {
    errorMessages: {
      errorCargarPdf: 'EF006: No pudimos abrir el documento PDF.Intente nuevamente en unos minutos.Si el problema continúa, comuníquese con soporte técnico.',
    },
  };
  
  export default texts;
  